<template>
    <modal name="create_location" height="auto" scrollable adaptive>
        <app-card :title="$t('Create location')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <app-multi-lang-input id="name"
                                          v-model="form.name"
                                          name="name"
                                          rules="required"
                                          :langs="locales && Object.keys(locales)">
                        <template #label>
                            {{ $t('Name') }}*
                        </template>
                    </app-multi-lang-input>
                    <app-checkbox id="main_location" v-model="form.main_location" name="main_location">
                        {{ $t('Main location') }}
                    </app-checkbox>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import LocationService from '@services/location.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                name: {
                    et: '',
                    en:''
                },
                main_location: false
            },
            loading: false
        };
    },
    computed: {
        ...mapGetters(['locales'])
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    LocationService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setLocation', res);
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_location');
        }
    }
};
</script>
